var DbStore = /** @class */ (function () {
    function DbStore(_a) {
        var _b = _a === void 0 ? {
            name: 'Changba.Resource.DB',
            version: 1.0,
            storeName: 'resource',
        } : _a, name = _b.name, version = _b.version, storeName = _b.storeName;
        this.storeName = storeName;
        this.dbPromise = new Promise(function (resolve, reject) {
            if (window.indexedDB) {
                var request_1 = window.indexedDB.open(name, version);
                request_1.onerror = function (err) {
                    reject(new Error('indexedDB open fail' + err));
                };
                request_1.onsuccess = function () {
                    resolve(request_1.result);
                };
                request_1.onupgradeneeded = function () {
                    var db = request_1.result;
                    db.createObjectStore(storeName);
                };
            }
            else {
                throw new Error('indexedDB not supported');
            }
        });
    }
    DbStore.prototype.has = function (key) {
        var _this = this;
        return this.dbPromise.then(function (db) {
            return new Promise(function (resolve, reject) {
                var transaction = db.transaction([_this.storeName], 'readonly');
                var objectStore = transaction.objectStore(_this.storeName);
                var request = objectStore.count(key);
                request.onsuccess = function () { return resolve(request.result > 0); };
                request.onerror = function (e) { return reject(e); };
            });
        });
    };
    DbStore.prototype.get = function (key) {
        var _this = this;
        return this.dbPromise.then(function (db) {
            return new Promise(function (resolve, reject) {
                var transaction = db.transaction([_this.storeName], 'readonly');
                var objectStore = transaction.objectStore(_this.storeName);
                var request = objectStore.get(key);
                request.onsuccess = function () { return resolve(request.result); };
                request.onerror = function (e) { return reject(e); };
            });
        });
    };
    DbStore.prototype.set = function (key, value) {
        var _this = this;
        return this.dbPromise.then(function (db) {
            return new Promise(function (resolve, reject) {
                var transaction = db.transaction([_this.storeName], 'readwrite');
                var objectStore = transaction.objectStore(_this.storeName);
                var request = objectStore.put(value, key);
                request.onsuccess = function () { return resolve(true); };
                request.onerror = function (e) { return reject(e); };
            });
        });
    };
    DbStore.prototype.delete = function (key) {
        var _this = this;
        return this.dbPromise.then(function (db) {
            return new Promise(function (resolve, reject) {
                var transaction = db.transaction([_this.storeName], 'readwrite');
                var objectStore = transaction.objectStore(_this.storeName);
                var request = objectStore.delete(key);
                request.onsuccess = function () { return resolve(true); };
                request.onerror = function (e) { return reject(e); };
            });
        });
    };
    return DbStore;
}());
export { DbStore };
